import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=f17c94c0&scoped=true"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17c94c0",
  null
  
)

export default component.exports